import './trademarkDisclaimer.css';

/**
 * Affiliation disclaimer for the games BeatHeaven's modes are compared to.
 * Comparative, "-inspired" references to these marks are defensible only while
 * we make clear BeatHeaven is an independent, unendorsed product — this is that
 * explicit statement. Rendered on every surface that names a competitor mark
 * (the six mode landings, the homepage, and the NCS song hub).
 */
export function TrademarkDisclaimer() {
  return (
    <p className="trademark-disclaimer">
      BeatHeaven is an independent project and is not affiliated with, endorsed
      by, or sponsored by osu!, Piano Tiles, Guitar Hero, Clone Hero, or Geometry
      Dash. All trademarks are the property of their respective owners.
    </p>
  );
}
